export default __webpack_public_path__ + "static/ab-8eafb121c48ba0434f8523d2c7f7f291.png";